/* ============================================================
   Terms of Service - static legal copy. The page module exists
   so the router can soft-navigate here and the shared chrome
   (header wallet button, toast) hydrates; there is nothing else
   to boot. TOS_VERSION in core/util.js must move in step with
   the "Last updated" date in terms.html.
   ============================================================ */
import "../../components/header/header.js";
import "../../components/footer/footer.js";
import "../../components/toast/toast.js";
import "../../components/section-head/section-head.js";

export function boot(){}
